import { useEffect } from 'react'
import { Text } from '~/@mid_ui/typography/Text'
import { cn } from '~/shadcn/lib/utils'

function ProjectDetailBlur() {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className="flex items-center justify-center fixed w-full h-[calc(100svh-70px)] top-[70px] left-0 right-0 z-1000 bg-foreground/50 backdrop-blur-[10px]">
      <div className="flex flex-col items-center justify-center gap-4 p-4">
        <div className="text-primary-foreground">
          <Text>
            Nahliadnuť do detailu tohto projektu môžu len zúčastnení investori.
          </Text>
        </div>
        <a
          className={cn(
            'rounded-full bg-accent text-primary-foreground px-4 py-2',
            'btn btn-next'
          )}
          href="/projects">
          <Text>Investičné projekty</Text>
        </a>
      </div>
    </div>
  )
}

export { ProjectDetailBlur }
